(() => {
  const VERSION = '1.0.0';

  class BPMysteryClassic extends HTMLElement {
    connectedCallback() {
      if (this.abortController) return;
      this.abortController = new AbortController();
      this.baseFaceCheckbox = this.querySelector('[data-bp-personalization="base-face"]');
      this.baseFaceProperty = this.querySelector('[data-bp-base-face-property]');
      this.addEventListener('change', () => this.sync(), { signal: this.abortController.signal });

      if (this.baseFaceCheckbox) this.baseFaceCheckbox.removeAttribute('name');
      queueMicrotask(() => {
        if (this.isConnected) this.sync();
      });
    }

    disconnectedCallback() {
      this.abortController?.abort();
      this.abortController = null;
    }

    get labels() {
      const skinTones = {};
      const undertones = {};
      this.querySelectorAll('[data-bp-personalization="skin-tone"]').forEach((input) => {
        skinTones[input.dataset.bpStateValue] = input.value;
      });
      this.querySelectorAll('[data-bp-personalization="undertone"]').forEach((input) => {
        undertones[input.dataset.bpStateValue] = input.value;
      });

      return {
        quantity: {
          fixedOne: this.dataset.labelFixedOne,
          fixedOther: this.dataset.labelFixedOther,
          range: this.dataset.labelRange,
        },
        publicQuantity: this.dataset.labelQuantity,
        publicMinimumValue: this.dataset.labelMinimumValue,
        publicSkinTone: this.dataset.labelSkinTone,
        publicUndertone: this.dataset.labelUndertone,
        publicBaseFace: this.dataset.labelBaseFace,
        skinTones,
        undertones,
        baseFaceExcluded: this.dataset.labelBaseExcluded,
        baseFaceNoExclusion: this.dataset.labelBaseNoExclusion,
      };
    }

    get state() {
      return {
        category: this.dataset.category,
        tier: this.dataset.tier,
        size: this.dataset.variantKey,
        skinTone: this.querySelector('[data-bp-personalization="skin-tone"]:checked')?.dataset.bpStateValue || null,
        undertone: this.querySelector('[data-bp-personalization="undertone"]:checked')?.dataset.bpStateValue || null,
        baseFaceOptOut: Boolean(this.baseFaceCheckbox?.checked),
      };
    }

    get variant() {
      return {
        id: this.dataset.variantId,
        productKey: this.dataset.productKey,
        variantKey: this.dataset.variantKey,
        sizeLabel: this.dataset.sizeLabel,
        priceCents: this.dataset.priceCents,
        itemCountMin: this.dataset.itemCountMin,
        itemCountMax: this.dataset.itemCountMax,
        minimumValueCents: this.dataset.minimumValueCents,
        minimumValueFormatted: this.dataset.minimumValueFormatted,
        weightGrams: this.dataset.weightGrams,
        available: this.dataset.available === 'true',
      };
    }

    sync() {
      const Core = window.BPMysteryBuilderCore;
      if (!Core) return;

      if (this.baseFaceProperty) {
        this.baseFaceProperty.value = this.baseFaceCheckbox?.checked
          ? this.dataset.labelBaseExcluded
          : this.dataset.labelBaseNoExclusion;
      }

      const validation = Core.validateVariantData(this.variant, {
        productConfigured: this.dataset.valid === 'true',
      });
      const form = document.getElementById(this.dataset.formId);
      if (!form) return;

      if (validation.valid) {
        const properties = Core.buildLineProperties(
          this.state,
          this.variant,
          this.labels,
          VERSION,
          { configuratorLabel: 'Pagina prodotto classica' },
        );
        this.querySelectorAll('[data-bp-property]').forEach((input) => {
          const propertyName = input.name?.match(/^properties\[(.*)]$/)?.[1];
          if (propertyName && Object.prototype.hasOwnProperty.call(properties, propertyName)) {
            input.value = String(properties[propertyName]);
          }
        });
      }

      if (!validation.valid) {
        form.querySelectorAll('[name="add"]').forEach((button) => {
          button.disabled = true;
          button.dataset.bpMysteryDisabled = 'true';
        });
      }
    }
  }

  if (!customElements.get('bp-mystery-classic')) {
    customElements.define('bp-mystery-classic', BPMysteryClassic);
  }

  document.addEventListener('shopify:section:load', (event) => {
    event.target.querySelectorAll('bp-mystery-classic').forEach((element) => element.connectedCallback());
  });
})();
